module.exports = __webpack_public_path__ + "static/img/ramp-8m-x-2m_256.dd2caae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ramp-8m-x-2m_256.png
// module id = BmRk
// module chunks = 0